// extracted by mini-css-extract-plugin
export default {"input-address-component":"AddressInputComponent_input-address-component__xBlri","input-addresss":"AddressInputComponent_input-addresss__5rQOE"};